import React from "react";
import { styled } from "@mui/material";
const InvalidSummary = styled("div")(({ theme }) => ({
  fontSize: 13,
  marginTop: 20,
  textAlign: "center",
  color: theme.palette.error.main,
}));

const InvalidSummaryMessage = () => {
  return (
    <InvalidSummary>
      Oops, invalid input. Please make sure the patient summary describes an
      individual case, and includes basic clinical information.
    </InvalidSummary>
  );
};

export default InvalidSummaryMessage;
